// extracted by mini-css-extract-plugin
module.exports = {"body":"ltHUb","container":"_245VB","text":"_2YATs","btn":"sxRQq"};